import axios from "axios"

export async function getFicheroIdFile(id: string): Promise<Blob> {
  const { data } = await axios.get(`Fichero/${id}/file`, {
    responseType: "blob",
  })
  return data
}
